interface Props {
    number: number;
}

export const NumberIcon = ({ number }: Props) => {
    return (
        <div
            className={
                'bg-primary-50 text-primary ml-2 flex h-5.5 w-5.5 items-center justify-center rounded-full text-[11px] font-semibold'
            }
        >
            {number}
        </div>
    );
};
